import Plyr from 'plyr'

var StreamVideo = {
	videoWrapper: null,
	videoOverlay: null,
	countdown: null,
	btnPlayOrPause: null,
	myInterval: null,
	player: null,
	elem: null,
	isUseScroll: true,
	isUseHover: true,
	isTouchVideoWrapper: false,
	isDisplayCountdown: false,
	isDoneDisplayCountdown: false,
	timeout: undefined,
	interval: undefined,
	i: 3,
	init: function () {
		this.processStream()
	},
	processStream() {
		try {
			const video = document.getElementById('player-element')
			this.elem = video
			const hls = new Hls({
				debug: false
			})
			let defaultOptions = {}
			let src = ''
			if (video.firstElementChild) {
				src = video.firstElementChild.getAttribute('src')
			}
			let _this = this
			this.videoWrapper = document.querySelector('.video-wrapper')
			this.videoOverlay = this.videoWrapper.querySelector('.video-overlay')
			this.countdown = this.videoOverlay.querySelector('.countdown')
			if (src.includes('.m3u8')) {
				hls.on(Hls.Events.MANIFEST_LOADED, function () {
					// Transform available levels into an array of integers (height values).
					const availableQualities = hls.levels.map((l) => l.height)
					availableQualities.unshift(0) //prepend 0 to quality array
					// Add new qualities to option
					defaultOptions.quality = {
						default: 0, //Default - AUTO
						options: availableQualities,
						forced: true,
						onChange: (e) => _this.updateQuality(e)
					}
					// Add Auto Label
					defaultOptions.i18n = {
						restart: 'Khôi phục',
						rewind: 'Tua lại {seektime}s',
						play: 'Play',
						pause: 'Dừng',
						fastForward: 'Tua nhanh {seektime}s',
						seek: 'Seek',
						seekLabel: '{currentTime} of {duration}',
						played: 'Đang play',
						buffered: 'Đang tải',
						currentTime: 'Thời gian hiện tại',
						duration: 'Thời lượng',
						volume: 'Âm lượng',
						mute: 'Tắt tiếng',
						unmute: 'Mở tiếng',
						enableCaptions: 'Enable captions',
						disableCaptions: 'Disable captions',
						download: 'Tải về',
						enterFullscreen: 'Toàn màn hình',
						exitFullscreen: 'Thhoát toàn màn hình',
						frameTitle: '{title}',
						captions: 'Captions',
						settings: 'Cài đặt',
						pip: 'PIP',
						menuBack: 'Go back to previous menu',
						speed: 'Tốc độ',
						normal: 'Bình thường',
						quality: 'Chất lượng',
						loop: 'Lặp lại',
						start: 'Bắt đầu',
						end: 'Kết thúc',
						all: 'Tất cả',
						reset: 'Khôi phục',
						disabled: 'Disabled',
						enabled: 'Enabled',
						advertisement: 'Ad',
						qualityLabel: {
							0: 'Tự động'
						}
					}

					// Initialize new Plyr player with quality options
					_this.player = new Plyr(video, defaultOptions)
					_this.player.muted = true
				})
				hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
					let span = document.querySelector('.plyr__menu__container [data-plyr=\'quality\'][value=\'0\'] span')
					if (hls.autoLevelEnabled) {
						span.innerHTML = `Tự động (${hls.levels[data.level].height}p)`
					} else {
						span.innerHTML = `Tự động`
					}
				})
				hls.loadSource(src)
				hls.attachMedia(video)
				window.hls = hls
			} else {
				this.player = new Plyr('#player-element')
				this.player.muted = true
			}


			window.addEventListener('scroll', function (e) {
				if (_this.isUseScroll) {
					_this.isUseHover = false
					if (_this.isOnScreen(video)) {
						if (!_this.isDisplayCountdown && !_this.isDoneDisplayCountdown) {
							_this.displayCountdown(video)
						}

					} else {
						if (_this.isDisplayCountdown && !_this.isDoneDisplayCountdown) {
							_this.clearDisplayCountdown()
						}
					}
				}
			})


			setTimeout(() => {
			}, 3000);


			this.videoWrapper.addEventListener('mouseover', function (e) {
				if (_this.isUseHover) {
					_this.isUseScroll = false
					if (!_this.isDisplayCountdown && !_this.isDoneDisplayCountdown) {
						_this.displayCountdown(video)
					}
				}
			})
			this.videoWrapper.addEventListener('mouseleave', function (e) {
				if (_this.isUseHover) {
					_this.isUseScroll = false
					if (_this.isDisplayCountdown && !_this.isDoneDisplayCountdown) {
						_this.clearDisplayCountdown()
					}
				}
			})


			this.videoOverlay.addEventListener('click', function (e) {
				if (_this.isDisplayCountdown) {
					_this.clearDisplayCountdown()
				}
				_this.playVideos()
				_this.isDoneDisplayCountdown = true
			})


		} catch (e) {
			console.log('Cannot video', e)
		}
	},
	playVideos() {
		this.player.play()
		this.openBtnPlayOrPause()
		let _this = this

		setTimeout(() => {
			if (_this.player.play() !== undefined) {
				_this.player.play().then(_ => {
					if (_this.checkRefresh()) {
						_this.player.muted = true
					}else {
						_this.player.volume = 0.5
					}
				}).catch(error => {
					console.log('home', error)
					_this.player.muted = true
					// Autoplay was prevented.
					// Show a "Play" button so that user can start playback.
				})
			}
		}, 2000)

		window.addEventListener('scroll', function () {
			if (!_this.isTouchVideoWrapper) {
				if (_this.isOnScreen(_this.elem)) {
					_this.player.play()
				} else {
					_this.player.pause()
				}
			}
		})
		this.videoWrapper.querySelector('.plyr__video-wrapper').addEventListener('click', function (e) {
			_this.isTouchVideoWrapper = true
		})
	},
	clearDisplayCountdown() {
		this.isDisplayCountdown = false
		this.i = 3
		clearInterval(this.myInterval)
		this.videoOverlay.classList.add('hidden')
	},
	displayCountdown(video) {
		this.isDisplayCountdown = true
		this.videoOverlay.classList.remove('hidden')
		this.countdown.textContent = this.i
		let _this = this
		this.myInterval = setInterval(() => {
			_this.i--
			_this.countdown.textContent = _this.i
			if (_this.isOnScreen(video)) {
				if (_this.i < 1) {
					_this.videoOverlay.classList.add('hidden')
					_this.isDoneDisplayCountdown = true
					clearInterval(_this.myInterval)
					_this.playVideos()
					return
				}
			} else {
				_this.clearDisplayCountdown()
			}
		}, 1000)
	},
	openBtnPlayOrPause() {
		// this.btnPlayOrPause = this.videoWrapper.querySelector('.plyr .plyr__control.plyr__control--overlaid')
		// Object.assign(this.btnPlayOrPause.style, {
		// 	display: 'block'
		// })
	},
	checkRefresh() {
		const pageAccessedByReload = (
			(window.performance.navigation && window.performance.navigation.type === 1) ||
			window.performance
				.getEntriesByType('navigation')
				.map((nav) => nav.type)
				.includes('reload')
		);

		return pageAccessedByReload
	},
	isOnScreen(elem) {
		var rect = elem.getBoundingClientRect()

		var elemOffsetTop = rect.top + window.scrollY
		var elemHeight = parseFloat(getComputedStyle(elem, null).height.replace('px', ''))

		var screenScrollTop = window.scrollY
		var screenHeight = window.innerHeight

		var scrollIsAboveElement = elemOffsetTop + elemHeight - screenScrollTop >= 0
		var elementIsVisibleOnScreen = screenScrollTop + screenHeight - elemOffsetTop >= 0

		return scrollIsAboveElement && elementIsVisibleOnScreen
	},
	updateQuality(newQuality) {
		if (newQuality === 0) {
			window.hls.currentLevel = -1 //Enable AUTO quality if option.value = 0
		} else {
			window.hls.levels.forEach((level, levelIndex) => {
				if (level.height === newQuality) {
					window.hls.currentLevel = levelIndex
				}
			})
		}
	}
}

export default window.addEventListener('DOMContentLoaded', function (e) {
	StreamVideo.init()
})
